import React, { useEffect, useState } from "react";
import { Button, Dialog } from '@mui/material';
import { useNavigate, useParams } from "react-router-dom";

import { useUserDetailsQuery, useUserDeleteMutation, useDisableUserMutation } from "services/user";
import { useOrgDetailsQuery } from "services/org";
import { useGetRoleByCodeQuery } from "services/role";
import { useSelector, useDispatch } from "react-redux";
import { resetRequestId } from 'api/user';
import { useUserCognitoDetailsQuery } from 'services/user';
import { setSubscriptionPopUp } from 'api/session';
import SubscriptionPopUp from "./popup";
import { useSubscriptionDetailsQuery } from "services/subscription";
import { resetSubscription } from "api/subscription";

const SubscriptionButton = (props) => {

    const { userId } = useParams();
    const dispatch = useDispatch();
    const navi = useNavigate();
    const requestId = useSelector(state => state.user.requestId);
    const [disableButton, setDisableButton] = useState(false);
    const subscriptionPopUp = useSelector(state => state.session.subscriptionPopUp);
    const [sb, setSB] = useState({ open: false, message: '', duration: 3000, severity: 'error' });

    const [userDeleteMutation] = useUserDeleteMutation();
    const [disableUser] = useDisableUserMutation();



    const { userDetails } = useUserDetailsQuery(
        {
            id: userId,
            requestId: requestId
        },
        {
            skip: !userId,
            selectFromResult: ({ data }) => ({
                userDetails: data || {}
            })
        }
    );





    const { subscriptionDetails } = useSubscriptionDetailsQuery({ priceId: userDetails.priceId },
        {
            skip: !userDetails.priceId,
            selectFromResult: ({ data }) => ({
                subscriptionDetails: data || {}
            })
        }
    );

    return (
        <React.Fragment>
            {subscriptionDetails?.price?.id ?
                <Button
                    variant='contained'
                    color="warning"
                    onClick={() => {
                        dispatch(setSubscriptionPopUp(true))
                    }}>
                    Edit Plan
                </Button>
                :
                <Button
                    variant='contained'
                    color="warning"
                    onClick={() => {
                        dispatch(resetSubscription())
                        dispatch(setSubscriptionPopUp(true))
                    }}>
                    Create Plan
                </Button>
            }
            <Dialog anchor={"top"} open={subscriptionPopUp} onClose={() => dispatch(setSubscriptionPopUp(false))}>
                <SubscriptionPopUp />
            </Dialog>
        </React.Fragment >
    )


}

export default SubscriptionButton;